(function () {
	'use strict';

	document.querySelectorAll('.gardp-filterable-projects').forEach(initBlock);

	function initBlock(block) {
		var postsPerPage = parseInt(block.dataset.postsPerPage, 10) || 6;
		var postsPerLoad = parseInt(block.dataset.postsPerLoad, 10) || 3;
		var readMoreLabel = block.dataset.readMoreLabel || 'Learn More';
		var scopedTypes = block.dataset.scopedTypes || '';
		var scopedProgrammes = block.dataset.scopedProgrammes || '';
		var totalPosts = parseInt(block.dataset.total, 10) || 0;
		var showType = block.dataset.showType !== '0' ? '1' : '0';
		var showProgramme = block.dataset.showProgramme !== '0' ? '1' : '0';
		var showReadMore = block.dataset.showReadMore !== '0' ? '1' : '0';

		var grid = block.querySelector('.gardp-filterable-projects__grid');
		var btnAll = block.querySelector('.gardp-filterable-projects__filter-all');
		var btnApply = block.querySelector('.gardp-filterable-projects__apply');
		var btnClear = block.querySelector('.gardp-filterable-projects__clear');
		var btnLoadMore = block.querySelector('.gardp-filterable-projects__load-more');
		var loadWrap = block.querySelector('.gardp-filterable-projects__load-more-wrap');
		var dropdowns = block.querySelectorAll('.gardp-filterable-projects__dropdown');
		var tagsContainer = block.querySelector('.gardp-filterable-projects__active-tags');
		var itemSelector = '.project-card';

		var activeFilters = { programme: [], type: [] };
		var filtersApplied = false;

		if (!grid) {
			return;
		}

		dropdowns.forEach(function (dd) {
			var toggle = dd.querySelector('.gardp-filterable-projects__dropdown-toggle');
			var panel = dd.querySelector('.gardp-filterable-projects__dropdown-panel');

			toggle.addEventListener('click', function (e) {
				e.stopPropagation();
				var isOpen = toggle.getAttribute('aria-expanded') === 'true';
				closeAllDropdowns();
				if (!isOpen) {
					toggle.setAttribute('aria-expanded', 'true');
					panel.hidden = false;
				}
			});

			panel.addEventListener('click', function (e) {
				e.stopPropagation();
			});
		});

		document.addEventListener('click', function () {
			closeAllDropdowns();
		});

		function closeAllDropdowns() {
			dropdowns.forEach(function (dd) {
				dd.querySelector('.gardp-filterable-projects__dropdown-toggle').setAttribute('aria-expanded', 'false');
				dd.querySelector('.gardp-filterable-projects__dropdown-panel').hidden = true;
			});
		}

		block.addEventListener('change', function (e) {
			if (!e.target.classList.contains('gardp-filterable-projects__checkbox')) return;
			syncPendingFilters();
		});

		function syncPendingFilters() {
			var pending = { programme: [], type: [] };
			dropdowns.forEach(function (dd) {
				var filterType = dd.dataset.filter;
				var checked = dd.querySelectorAll('.gardp-filterable-projects__checkbox:checked');
				checked.forEach(function (cb) {
					pending[filterType].push(parseInt(cb.value, 10));
				});
				if (pending[filterType].length > 0) {
					dd.classList.add('gardp-filterable-projects__dropdown--active');
				} else {
					dd.classList.remove('gardp-filterable-projects__dropdown--active');
				}
			});

			var hasSelection = pending.programme.length > 0 || pending.type.length > 0;
			if (btnApply) btnApply.disabled = !hasSelection;
			return pending;
		}

		function getCheckedSlugs(filterType) {
			var slugs = [];
			var dd = block.querySelector('.gardp-filterable-projects__dropdown[data-filter="' + filterType + '"]');
			if (!dd) return slugs;
			dd.querySelectorAll('.gardp-filterable-projects__checkbox:checked').forEach(function (cb) {
				if (cb.dataset.slug) slugs.push(cb.dataset.slug);
			});
			return slugs;
		}

		function updateUrlParams() {
			var programmeSlugs = getCheckedSlugs('programme');
			var typeSlugs = getCheckedSlugs('type');
			var parts = [];

			if (programmeSlugs.length) parts.push('programme=' + programmeSlugs.join(','));
			if (typeSlugs.length) parts.push('type=' + typeSlugs.join(','));

			var newUrl = window.location.pathname + (parts.length ? '?' + parts.join('&') : '');
			history.replaceState(null, '', newUrl);
		}

		function applyUrlPrefilters() {
			var url = new URL(window.location);
			var programmeSlugs = (url.searchParams.get('programme') || '').split(',').filter(Boolean);
			var typeSlugs = (url.searchParams.get('type') || '').split(',').filter(Boolean);

			if (!programmeSlugs.length && !typeSlugs.length) {
				updateLoadMoreVisibility();
				return;
			}

			function checkBySlug(filterType, slugs) {
				var dd = block.querySelector('.gardp-filterable-projects__dropdown[data-filter="' + filterType + '"]');
				if (!dd) return;
				slugs.forEach(function (slug) {
					var cb = dd.querySelector('.gardp-filterable-projects__checkbox[data-slug="' + slug + '"]');
					if (cb) cb.checked = true;
				});
			}

			checkBySlug('programme', programmeSlugs);
			checkBySlug('type', typeSlugs);

			activeFilters = syncPendingFilters();
			filtersApplied = activeFilters.programme.length > 0 || activeFilters.type.length > 0;

			if (filtersApplied) {
				if (btnAll) btnAll.classList.remove('gardp-filterable-projects__filter-all--active');
				if (btnClear) btnClear.hidden = false;
				renderActiveTags();
				fetchProjects(true);
			}
		}

		function updateLoadMoreVisibility() {
			if (!loadWrap) return;
			var shown = grid.querySelectorAll(itemSelector).length;
			loadWrap.hidden = totalPosts === 0 || shown >= totalPosts;
		}

		if (btnApply) {
			btnApply.addEventListener('click', function () {
				activeFilters = syncPendingFilters();
				filtersApplied = activeFilters.programme.length > 0 || activeFilters.type.length > 0;
				closeAllDropdowns();
				fetchProjects(true);
				renderActiveTags();
				updateUrlParams();
				if (filtersApplied) {
					btnAll.classList.remove('gardp-filterable-projects__filter-all--active');
					if (btnClear) btnClear.hidden = false;
				}
			});
		}

		if (btnClear) {
			btnClear.addEventListener('click', function () {
				resetFilters();
			});
		}

		if (btnAll) {
			btnAll.addEventListener('click', function () {
				resetFilters();
			});
		}

		function resetFilters() {
			block.querySelectorAll('.gardp-filterable-projects__checkbox:checked').forEach(function (cb) {
				cb.checked = false;
			});
			dropdowns.forEach(function (dd) {
				dd.classList.remove('gardp-filterable-projects__dropdown--active');
			});
			activeFilters = { programme: [], type: [] };
			filtersApplied = false;
			if (btnApply) btnApply.disabled = true;
			if (btnClear) btnClear.hidden = true;
			btnAll.classList.add('gardp-filterable-projects__filter-all--active');
			clearActiveTags();
			closeAllDropdowns();
			updateUrlParams();
			fetchProjects(true);
		}

		function renderActiveTags() {
			if (!tagsContainer) return;
			tagsContainer.innerHTML = '';

			block.querySelectorAll('.gardp-filterable-projects__checkbox:checked').forEach(function (cb) {
				var tag = document.createElement('span');
				tag.className = 'gardp-filterable-projects__tag';
				tag.setAttribute('data-filter', cb.closest('.gardp-filterable-projects__dropdown').dataset.filter);
				tag.setAttribute('data-value', cb.value);

				var label = document.createElement('span');
				label.className = 'gardp-filterable-projects__tag-label';
				label.textContent = cb.dataset.label || cb.value;

				var removeBtn = document.createElement('button');
				removeBtn.className = 'gardp-filterable-projects__tag-remove';
				removeBtn.setAttribute('type', 'button');
				removeBtn.setAttribute('aria-label', 'Remove ' + (cb.dataset.label || cb.value));
				removeBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

				tag.appendChild(label);
				tag.appendChild(removeBtn);
				tagsContainer.appendChild(tag);
			});

			tagsContainer.hidden = tagsContainer.children.length === 0;
		}

		function clearActiveTags() {
			if (!tagsContainer) return;
			tagsContainer.innerHTML = '';
			tagsContainer.hidden = true;
		}

		if (tagsContainer) {
			tagsContainer.addEventListener('click', function (e) {
				var removeBtn = e.target.closest('.gardp-filterable-projects__tag-remove');
				if (!removeBtn) return;
				var tag = removeBtn.closest('.gardp-filterable-projects__tag');
				var filterType = tag.dataset.filter;
				var value = tag.dataset.value;
				var checkbox = block.querySelector(
					'.gardp-filterable-projects__dropdown[data-filter="' + filterType + '"] .gardp-filterable-projects__checkbox[value="' + value + '"]'
				);
				if (checkbox) checkbox.checked = false;
				activeFilters = syncPendingFilters();
				filtersApplied = activeFilters.programme.length > 0 || activeFilters.type.length > 0;
				if (!filtersApplied) {
					btnAll.classList.add('gardp-filterable-projects__filter-all--active');
					if (btnClear) btnClear.hidden = true;
					if (btnApply) btnApply.disabled = true;
				}
				fetchProjects(true);
				renderActiveTags();
				updateUrlParams();
			});
		}

		if (btnLoadMore) {
			btnLoadMore.addEventListener('click', function () {
				fetchProjects(false);
			});
		}

		function fetchProjects(replace) {
			var currentlyShown = replace ? 0 : grid.querySelectorAll(itemSelector).length;
			var perPage = replace ? postsPerPage : postsPerLoad;
			var params = new URLSearchParams();
			params.append('offset', currentlyShown);
			params.append('per_page', perPage);
			params.append('read_more_label', readMoreLabel);
			params.append('show_type', showType);
			params.append('show_programme', showProgramme);
			params.append('show_read_more', showReadMore);
			if (activeFilters.programme.length) params.append('programme', activeFilters.programme.join(','));
			if (activeFilters.type.length) params.append('type', activeFilters.type.join(','));
			if (scopedTypes) params.append('scoped_types', scopedTypes);
			if (scopedProgrammes) params.append('scoped_programmes', scopedProgrammes);

			var url = (window.gardpFilterableProjects && window.gardpFilterableProjects.restUrl)
				? window.gardpFilterableProjects.restUrl
				: '/wp-json/gardp/v1/filterable-projects';

			if (btnLoadMore) btnLoadMore.classList.add('is-loading');
			fetch(url + '?' + params.toString())
				.then(function (res) {
					if (!res.ok) throw new Error('HTTP ' + res.status);
					return res.json();
				})
				.then(function (data) {
					if (replace) {
						grid.innerHTML = data.html || '';
					} else {
						grid.insertAdjacentHTML('beforeend', data.html || '');
					}
					totalPosts = parseInt(data.total, 10) || 0;

					if (totalPosts === 0 && replace) {
						grid.innerHTML = '<div class="gardp-filterable-projects__empty"><p class="gardp-filterable-projects__empty-heading">No results found</p><p class="gardp-filterable-projects__empty-text">Try adjusting or clearing your filters to see more results.</p></div>';
					}

					updateLoadMoreVisibility();
				})
				.catch(function (err) {
					console.error('Filterable Projects fetch error:', err);
				})
				.finally(function () {
					if (btnLoadMore) btnLoadMore.classList.remove('is-loading');
				});
		}

		applyUrlPrefilters();
	}
})();
